// 把 InventorySelectorModal 回傳的 row（inventory_type 為物件 { id, name, code }）
// 正規化成 TransformationItemModal 期望的 shape：
//   - inventory_type: 字串（顯示用名稱）
//   - inventory_type_id: 獨立欄位（後端 id）
// 對齊 list endpoint 的 InventoryTableRow 合約，以及 Edit.jsx restore path
// (source_inventory_type_name → inventory_type / source_inventory_type_id → inventory_type_id)。

type InventoryTypeObject = {
  id?: string;
  name?: string;
  [key: string]: unknown;
};

type SelectorInventoryInput = {
  inventory_type?: InventoryTypeObject | string | null;
  inventory_type_id?: string;
  [key: string]: unknown;
};

type NormalizedInventory<T extends SelectorInventoryInput> = Omit<T, 'inventory_type'> & {
  inventory_type?: string;
  inventory_type_id?: string;
};

export function normalizeSelectorInventory<T extends SelectorInventoryInput>(
  inventory: T,
): NormalizedInventory<T> {
  const { inventory_type, inventory_type_id, ...rest } = inventory;

  // 容錯：input 已是字串時直接 passthrough，並沿用既有的 inventory_type_id（若有）
  if (typeof inventory_type === 'string') {
    return {
      ...(rest as Omit<T, 'inventory_type'>),
      inventory_type,
      inventory_type_id,
    };
  }

  return {
    ...(rest as Omit<T, 'inventory_type'>),
    inventory_type: inventory_type?.name,
    inventory_type_id: inventory_type?.id ?? inventory_type_id,
  };
}
